<template>
  <div class="relative overflow-hidden lg:pb-10">
    <div class="relative mb-8 lg:mb-12">
      <picture>
        <source :srcset="artwork.full_image.lg" media="(min-width: 1024px)">
        <img
          loading="lazy"
          :src="artwork.full_image.sm"
          :alt="artwork.alt_image"
          class="w-full bg-light-gray"
          :width="artwork.full_image_dimensions[0]"
          :height="artwork.full_image_dimensions[1]">
      </picture>
      <div class="absolute inset-0">
        <sold-ribbon v-if="artwork.is_sold"></sold-ribbon>
        <reserved-ribbon v-if="artwork.is_reserved"></reserved-ribbon>
      </div>
      <a :href="artwork.url" :title="artwork.title" class="absolute inset-0"></a>
    </div>
    <div class="flex flex-col lg:flex-row lg:justify-between lg:items-baseline">
      <a :href="artwork.url" :title="artwork.title"
        class="uppercase link link-accent font-bold text-14 leading-1.25 pr-36 lg:pr-0 lg:text-16 mb-6 mr-8">
        <h3 v-if="page.startsWith('/artists/') || page.startsWith('/exhibitions/')">{{ artwork.title }}</h3>
        <h2 v-else>{{ artwork.title }}</h2>
      </a>
      <span class="mb-6 text-12 text-dark-gray lg:text-14 lg:flex-none">{{ dimensions }}</span>

      <div v-if="! this.$mq.lg && withFavoriteButton" class="absolute right-0 text-12 lg:text-14">
        <favorite-button :artwork="artwork"></favorite-button>
      </div>
    </div>
    <div class="flex flex-col lg:flex-row italic">
      <div>
        <div class="text-12 leading-1.2 text-dark-gray mb-4 lg:text-14 lg:mb-8">
          <div v-if="artwork.artist.data.isShownOnWebsite">
            <a :href="artwork.artist.data.url" class="link link-supporting">
              <h4 v-if="page.startsWith('/artists/') || page.startsWith('/exhibitions/')" class="inline-block">
                {{ artwork.artist.data.name }}
              </h4>

              <h2 v-else class="inline-block">{{ artwork.artist.data.name }}</h2>
            </a>,
            <h3 class="inline-block"> {{ artwork.year_made }} </h3>
          </div>
          <div v-else>
            {{ artwork.artist.data.name }}, {{ artwork.year_made }}
          </div>
        </div>
        <div class="text-12 leading-1.2 text-dark-gray lg:text-14" v-if="! artwork.is_sold">
          <h3 v-if="page.startsWith('/artists/')">{{ artwork.price_with_currency }}</h3>
          <h4 v-else>{{ artwork.price_with_currency }}</h4>
        </div>
      </div>
      <div v-if="withCartButton || withFavoriteButton" class="lg:ml-auto lg:mt-0 absolute lg:relative top-4 right-4">
        <div class="flex">
          <div class="mr-4 text-12 lg:text-14">
            <favorite-button v-if="withFavoriteButton && this.$mq.lg" :artwork="artwork"></favorite-button>
          </div>

          <add-to-cart-button
            mini
            v-if="! artwork.is_sold && ! artwork.is_reserved && withCartButton"
            :artwork="artwork"
            :status="status"
            @added="$emit('update:artwork', $event)">
          </add-to-cart-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    artwork: {
      type: Object,
      required: true,
    },

    withCartButton: {
      default: true
    },

    withFavoriteButton: {
      default: true
    }
  },

  computed: {
    page () {
      return window.location.pathname
    },

    status () {
      if (this.artwork.status === 'Available') {
        return 'available'
      }

      if (this.artwork.status === 'Sold') {
        return 'sold'
      }

      if (this.artwork.is_in_cart) {
        return 'in-cart'
      }

      if (this.artwork.is_reserved) {
        return 'reserved'
      }
    },

    dimensions () {
      return [this.artwork.height, this.artwork.width, this.artwork.depth]
        .map(value => Number(value))
        .filter(value => value)
        .map(value => value.toLocaleString() + '"')
        .join(' x ')
    },
  },
}
</script>
